<template>
  <div>
    <v-card class="mb-5">
      <v-card-title>
        Количество превышении по датам

        <v-spacer></v-spacer>
        <!--      <v-text-field-->
        <!--        v-model="search"-->
        <!--        @input="apiSearch"-->
        <!--        append-icon="mdi-magnify"-->
        <!--        label="Поиск по результатам"-->
        <!--        single-line-->
        <!--        hide-details-->
        <!--      />-->
      </v-card-title>

      <v-data-table
        :headers="excessHeaders"
        :items="excessItems"
        :loading="loading"
        :options.sync="options"
        :server-items-length="meta.total"
        @click:row="showDetail"
      >
        <template v-slot:top>
          <v-container fluid>
            <v-row no-gutters justify="space-between">
              <v-col cols="12" sm="3" class="mr-3">
                <DateRangePicker v-model="filters.date" @input="load" />
              </v-col>
            </v-row>
            <div v-if="excessItems.length && showMedParamsExcessMeasurementChart">
              <IkpMedParamsExcessMeasurementChart :items="excessItems" :height="200" />
            </div>
          </v-container>
        </template>
      </v-data-table>
    </v-card>
    <v-card class="mb-5">
      <v-card-title>
        Среднее значения параметров по датам

        <v-spacer></v-spacer>
        <!--      <v-text-field-->
        <!--        v-model="search"-->
        <!--        @input="apiSearch"-->
        <!--        append-icon="mdi-magnify"-->
        <!--        label="Поиск по результатам"-->
        <!--        single-line-->
        <!--        hide-details-->
        <!--      />-->
      </v-card-title>

      <v-data-table :headers="averageHeaders" :items="averageItems" :loading="loading" @click:row="showAverageDetail">
        <template v-slot:top>
          <v-container fluid>
            <div v-if="averageItems.length && showMedParamsAverageMeasurementChart">
              <IkpMedParamsAverageMeasurementChart :items="averageItems" :height="200" />
            </div>
          </v-container>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import throttle from "lodash/throttle";
import DateRangePicker from "@/components/forms/DateRangePicker.vue";
import IkpMedParamsExcessMeasurementChart from "@/views/pages/ikp/components/IkpMedParamsExcessMeasurementChart.vue";
import ModalIkpMedParamDetail from "@/views/pages/ikp/components/ModalIkpMedParamDetail.vue";
import IkpMedParamsAverageMeasurementChart from "@/views/pages/ikp/components/IkpMedParamsAverageMeasurementChart.vue";

export default {
  name: "IkpMedParamsExcessMeasurement",

  components: { IkpMedParamsAverageMeasurementChart, IkpMedParamsExcessMeasurementChart, DateRangePicker },

  props: {
    showMedParamsAverageMeasurementChart: {
      type: Boolean,
      default: true,
    },
    showMedParamsExcessMeasurementChart: {
      type: Boolean,
      default: true,
    },
  },

  data: () => ({
    loading: false,
    options: {},
    filters: {
      date: [],
    },
    search: "",
    excessHeaders: [
      {
        text: "Дата",
        align: "start",
        sortable: false,
        value: "date_without_time",
      },
      {
        text: "Параметр",
        align: "start",
        sortable: false,
        value: "med_param_name",
      },
      {
        text: "Кол. Превышений",
        align: "start",
        sortable: false,
        value: "result",
      },
    ],
    averageHeaders: [
      {
        text: "Дата",
        align: "start",
        sortable: false,
        value: "date_without_time",
      },
      {
        text: "Параметр",
        align: "start",
        sortable: false,
        value: "med_param_name",
      },
      {
        text: "Среднее",
        align: "start",
        sortable: false,
        value: "med_param_value",
      },
    ],
    excessItems: [],
    averageItems: [],
    meta: {
      total: 0,
    },
  }),

  computed: {
    customerId() {
      return this.$store.state.customer.id;
    },
  },

  watch: {
    options: {
      handler() {
        this.load();
      },
      deep: true,
    },
  },

  methods: {
    async load() {
      this.loading = true;

      try {
        const { sortBy, sortDesc, page, itemsPerPage } = this.options;
        const params = {
          page: page,
          limit: itemsPerPage === -1 ? this.meta.total : itemsPerPage,
          sort: "",
          sort_direction: "",
          search: this.search,
          "filter[date]": this.filters.date,
          "filter[med_params]": [387], // 387 - работоспособность
        };

        if (sortBy.length === 1 && sortDesc.length === 1) {
          params.sort = sortBy[0];
          params.sort_direction = sortDesc[0] ? "desc" : "asc";
        }

        const response = await this.$http.get(`v1/customers/${this.customerId}/params/excess-measurement`, {
          params,
        });
        this.excessItems = response.data.data;
        this.meta.total = response.data.meta.total;
      } catch (e) {
        // TODO: Обработать ошибку
        console.error(e);

        this.excessItems = [];
        this.meta.total = 0;
      }

      if (this.excessItems.length) {
        try {
          const response = await this.$http.get(`v1/customers/${this.customerId}/params/average-measurement`, {
            params: {
              "filter[dates]": [...new Set(this.excessItems.map(item => item.date_without_time))],
              "filter[med_params]": [387], // 387 - работоспособность
            },
          });
          this.averageItems = response.data.data;
        } catch (e) {
          // TODO: Обработать ошибку
          console.error(e);
          this.averageItems = [];
        }
      }

      this.loading = false;
    },

    apiSearch: throttle(async function apiSearchHandler() {
      await this.load();
    }, 1000),

    showDetail(data) {
      this.$dialog.show(ModalIkpMedParamDetail, { itemMedParam: data, width: 600 });
    },

    showAverageDetail(data) {
      this.$dialog.show(ModalIkpMedParamDetail, { itemMedParam: data, width: 600 });
    },
  },
};
</script>

<style scoped></style>
